import {Injectable, OnDestroy, signal} from '@angular/core';
import {Subject, take, takeUntil} from 'rxjs';
import {UserApi} from '@domain/user/user.api';
import {MemberDTO} from '@domain/member/member.dto';
import {AuthService} from '@core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserMembershipSelectorService implements OnDestroy {

  private readonly _memberships = signal<MemberDTO[] | null>(null);
  private readonly _currentMembership = signal<MemberDTO | null>(null);

  public readonly memberships = this._memberships.asReadonly();
  public readonly currentMembership = this._currentMembership.asReadonly();

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly authService: AuthService,
    private readonly userApi: UserApi
  ) {
    this.authService.getAuthenticatedUserUpdates().pipe(
      takeUntil(this.destroy$)
    ).subscribe(user => {
      this._memberships.set(user?.memberships ?? null);
      this._currentMembership.set(user?.currentMembership ?? null);
    });
  }

  public setCurrentMembership(membership: MemberDTO | null): void {
    if (!membership?.id) {
      return;
    }
    this.userApi.setCurrentMembership(membership.id).pipe(
      take(1)
    ).subscribe(_ => {
      this._currentMembership.set(membership);
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
